import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ReleaseRetentionApi } from "../../../../Api/Operations/WorkOrders";
import { getallbanks } from "../../../../Redux/actions/getbanks";
import ActionButton from "../../../Common/ActionButton";

export default function RetentionReleaseModal({ isOpen, onClose, woData, onSuccess }) {
  const dispatch = useDispatch();
  const banksData = useSelector((state) => state.getAllBanksReducer?.data || []);
  // This modal always opens against one specific WO — use its own project, not
  // whatever's active in the top nav. Old:
  // const { session } = useSession();
  // const projectId = session?.ProjectId;
  const projectId = woData?.ProjectId;

  const [releaseDate, setReleaseDate] = useState(moment().format("YYYY-MM-DD"));
  const [bankAccountId, setBankAccountId] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    dispatch(getallbanks(projectId));
  }, [isOpen, dispatch, projectId]);

  if (!isOpen) {
    return null;
  }

  const validate = () => {
    if (!releaseDate) {
      toast.info("Release date is required");
      return false;
    }
    if (!bankAccountId) {
      toast.info("Please select a bank account");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }
    setSubmitting(true);
    try {
      const payload = {
        workOrderId: woData?.Id,
        releaseDate: new Date(releaseDate).toISOString(),
        bankAccountId: Number(bankAccountId),
      };

      const res = await ReleaseRetentionApi(payload);
      const json = res?.data || res;
      if (json?.IsSuccess) {
        toast.success(json.Message || "Retention released successfully");
        onSuccess?.();
      } else {
        toast.error(json?.Message || "Failed to release retention");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error releasing retention");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modalscreen" style={{ display: "block", height: "100vh", overflow: "auto" }}>
      <div className="modal-content-screen1">
        <div className="row sticky-topNew">
          <div className="col-12 page_heading">
            <h4 className="text-center mb-0">Release Retention</h4>
            <span className="close pr-2" onClick={onClose}>
              &times;
            </span>
          </div>
        </div>

        <div className="pl-3 pr-3">
          <div className="row">
            <div className="col-md-2 mt-md-4 text-left p-0">
              <label className="input_label m-0">Release Date:</label>
            </div>
            <div className="col-md-3 mt-md-4 p-0 d-flex">
              <input
                type="date"
                className="input_styling ml-md-3"
                value={releaseDate}
                onChange={(e) => setReleaseDate(e.target.value)}
              />
              <span className="estaric">*</span>
            </div>
            <div className="col-md-2 mt-md-4 text-left p-0"></div>

            <div className="col-md-2 mt-md-4 text-left p-0">
              <label className="input_label m-0">Bank Account:</label>
            </div>
            <div className="col-md-3 mt-md-4 p-0 d-flex">
              <select
                className="input_styling ml-md-3"
                value={bankAccountId}
                onChange={(e) => setBankAccountId(e.target.value)}
              >
                <option value="">Select Bank Account</option>
                {banksData?.map((bank) => (
                  <option key={bank.AccountId} value={bank.AccountId}>
                    {bank.AccountTitle}
                  </option>
                ))}
              </select>
              <span className="estaric">*</span>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 d-flex justify-content-end" style={{ gap: 8 }}>
              <ActionButton
                text="Cancel"
                variant="cancel"
                onClick={onClose}
                disabled={submitting}
              />
              <ActionButton
                text={submitting ? "Please wait..." : "Release Retention"}
                variant="save"
                onClick={handleSubmit}
                disabled={submitting}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
